module.exports = __webpack_public_path__ + "static/media/add billing.d70ded2c.svg";